import { get, post, put, del, patch } from './fetcher';

const ENDPOINTS = {
  CONFIG: '/api/admin/scraping/config',
  SCHEDULES: '/api/admin/scraping/schedules',
  SCHEDULE: (id) => `/api/admin/scraping/schedules/${id}`,
  SCHEDULE_TOGGLE: (id) => `/api/admin/scraping/schedules/${id}/toggle`,
};

const unwrap = (response, fallbackMessage) => {
  if (response && response.success) return response.data;
  throw new Error((response && response.message) || fallbackMessage);
};

// ---------------- 설정(config) ----------------
export const getCrawlingConfig = async (token) => {
  const response = await get(ENDPOINTS.CONFIG, {}, token);
  return unwrap(response, '크롤링 설정 조회에 실패했습니다.');
};

export const saveCrawlingConfig = async (token, payload) => {
  const response = await put(ENDPOINTS.CONFIG, payload, token);
  return unwrap(response, '크롤링 설정 저장에 실패했습니다.');
};

// ---------------- 스케줄(schedule) ----------------
export const getCrawlingSchedules = async (token) => {
  const response = await get(ENDPOINTS.SCHEDULES, {}, token);
  const data = unwrap(response, '스케줄 목록 조회에 실패했습니다.');
  return (data && data.items) || [];
};

export const createCrawlingSchedule = async (token, payload) => {
  const response = await post(ENDPOINTS.SCHEDULES, payload, token);
  return unwrap(response, '스케줄 생성에 실패했습니다.');
};

export const updateCrawlingSchedule = async (token, id, payload) => {
  const response = await put(ENDPOINTS.SCHEDULE(id), payload, token);
  return unwrap(response, '스케줄 수정에 실패했습니다.');
};

export const deleteCrawlingSchedule = async (token, id) => {
  const response = await del(ENDPOINTS.SCHEDULE(id), {}, token);
  return unwrap(response, '스케줄 삭제에 실패했습니다.');
};

export const toggleCrawlingSchedule = async (token, id) => {
  const response = await patch(ENDPOINTS.SCHEDULE_TOGGLE(id), {}, token);
  return unwrap(response, '스케줄 상태 변경에 실패했습니다.');
};
